import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-lua";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools";

const Code = ({ value, onChange }) => {
    const [code,setCode] = useState(value);
    console.log("Code:",value);
    function onChange1(newValue) {
        setCode(newValue);
        //console.log("change", newValue);
      }

    useEffect(()=>{
        setCode(value);
    },[value]);
      
    return (
        <AceEditor
            className="p-4"
            height="400px"
            width="100%"
            onBlur={()=>{
                onChange(code);
            }}
            value={code}
            mode="lua"
            theme="github"
            onChange={onChange1}
            name="UNIQUE_ID_OF_DIV"
            editorProps={{ $blockScrolling: true }}
            setOptions={{
                enableBasicAutocompletion: true,
                enableSnippets: true,
                enableLiveAutocompletion: true,
                useWorker: false,
            }}
        />
    );
}

export default Code;
